import React from 'react';
import { MarketCodeSchema } from '@schuettflix/utils';
import { MarketContextProvider, useMarketContext } from '@/shared/context/MarketContext.tsx';
import { HttpClientContextProvider } from '@/shared/context/HttpClientContext.tsx';
import { PositionLoader } from '@/routes/loaders/PositionLoader.tsx';
import { MessageBox } from '@schuettflix/react-components';
import { DirectFulfillmentPage } from '@/modules/fulfillment/DirectFulfillmentPage.tsx';
import { getProcessingTypeFromEntity } from '@/shared/utils/getProcessingTypeFromEntity.ts';
import { GetPositionConfigurationResponse } from '@/shared/types/positionV2/api/get-position-configuration.ts';

type InnerOrderRouteProps = {
    positionV2?: GetPositionConfigurationResponse;
};

function InnerDirectFulfillmentRoute({ positionV2 }: InnerOrderRouteProps) {
    const { marketCode: contextMarketCode } = useMarketContext();
    const marketCode = positionV2 ? MarketCodeSchema.parse(positionV2.marketCode) : contextMarketCode;

    if (!positionV2) {
        return (
            <MessageBox type="error" title="Error">
                No position found.
            </MessageBox>
        );
    }

    if (positionV2.status !== 'OPEN') {
        return (
            <MessageBox type="error" title="Error">
                {`Cannot access DirectFulfillmentPage with position status: ${positionV2.status}`}
            </MessageBox>
        );
    }

    if (getProcessingTypeFromEntity(positionV2) === 'AUTOMATIC') {
        return (
            <MessageBox type="error" title="Error">
                {`Cannot access DirectFulfillmentPage with an Automatically fulfilled position: ${positionV2.number}`}
            </MessageBox>
        );
    }

    return (
        <MarketContextProvider marketCode={marketCode}>
            <HttpClientContextProvider marketCode={marketCode}>
                <DirectFulfillmentPage position={positionV2} />
            </HttpClientContextProvider>
        </MarketContextProvider>
    );
}

export const DirectFulfillmentRoute = PositionLoader(InnerDirectFulfillmentRoute);
